import { Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Store } from '@ngxs/store';
import { DEFAULT_DATE_TIME_FORMAT } from 'src/app/core/ccomx-date-formats';
import { EditCrewMemberDatesModalComponent } from 'src/app/crew-management-user/modals/edit-crew-member-dates-modal/edit-crew-member-dates-modal.component';
import { DeletePaxFromTrip } from 'src/app/crew-management-user/state/trips/trip.actions';
import { IPax } from 'src/app/user/models/pax.model';
import { Privileges } from 'src/app/core/privileges/privileges';

@Component({
  selector: 'app-trip-paxes-template',
  templateUrl: './trip-paxes-template.component.html',
  standalone: false,
  styleUrls: ['./trip-paxes-template.component.scss'],
})
export class TripPaxesTemplateComponent {
  @Input() columnName: string;
  @Input() element: any;

  dateTimeFormat = DEFAULT_DATE_TIME_FORMAT;
  Privileges = Privileges;

  constructor(
    private store: Store,
    private dialog: MatDialog
  ) {}

  editPax(
    pax: IPax & {
      tripId: string;
      paxId: string;
    }
  ) {
    this.dialog
      .open(EditCrewMemberDatesModalComponent, {
        width: '35rem',
        panelClass: 'mobile-sizing-for-mat-dialogs',
        data: { ...pax, isPax: true },
      })
      .afterClosed()
      .subscribe();
  }

  deletePax(pax: IPax & { tripId: string; paxId: string }) {
    this.store.dispatch(new DeletePaxFromTrip(pax.tripId, [pax.paxId]));
  }
}
